import enableSaveQuoteAgent from 'core/controllerPlans/enableSaveQuoteAgent'
import sendEmailFromAgent from 'core/services/email/sendEmailFromAgent'
import isSalesCenterAgent from 'utils/pivot/agent/isSalesCenterAgent'
import { IS_AGENT, IS_FIXED_BENEFIT_MEDICAL } from 'core/constants/environment'
import store from 'utils/store/withMiddleware'
import makePayload from './makePayload'
import { default as makePayloadSingular } from 'core/services/email/sendEmailFromAgent/singular/makePayload'
import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { findFirstOccurrence } from '@hc-frontend/utils'
import { LATITUDE } from 'core/constants/products'
import isSTMPlan from 'utils/pivot/plan/isSTMPlan'
import { DETAILS } from 'sites/routes'
import { sendEmailQuoteEvent } from 'core/services/email/blueshift/implementations/email-quote'
import makeFBMPlansPayload from './makeFBMPlansPayload'

const sendFBMPlansViaEmail = (valuesForm, agentInformation, config, salesCenterAgent) => {
  const parameters = {
    valuesForm,
    agentInformation,
    salesCenterAgent
  }

  const data = makeFBMPlansPayload(parameters)

  return sendEmailFromAgent({
    config,
    data
  })
}

const sendQuoteViaEmail = (
  valuesForm,
  agentInformation,
  config,
  salesCenterAgent,
  propertyPlanId
) => {
  const state = store.getState()
  const latitudeId =
    findFirstOccurrence(state.plansAddon, state.plansByType[LATITUDE]) || state.latitudeId
  const dentalId = state.dentalPlanId

  const promises = [
    dentalId &&
      fetchJSONHandleError({
        url: state.jsons[state.plans[dentalId].jsonId]
      }),
    latitudeId &&
      fetchJSONHandleError({
        url: state.jsons[state.plans[latitudeId].jsonId]
      })
  ]

  Promise.all(promises)
    .then(([dentalJson, latitudeJson]) => {
      const parameters = {
        placement: config.placement,
        valuesForm,
        agentInformation,
        salesCenterAgent,
        propertyPlanId,
        dentalJson,
        latitudeJson,
        path: DETAILS
      }

      const data = isSTMPlan(state.hcStorage.pivotPlan)
        ? makePayloadSingular(parameters)
        : makePayload(parameters)

      return data
    })
    .then(data => {
      const quote = data.message.global_merge_vars.find(item => item.name === 'plan')
        .content.link
      sendEmailQuoteEvent(quote)
      return data
    })
    .then(data => {
      return sendEmailFromAgent({
        config,
        data
      })
    })
}

async function saveThisQuoteConfig({
  config,
  propertyPlanId = 'planId',
  enable = () => {
    return
  }
}) {
  if (!IS_AGENT) return

  const firstState = store.getState()

  const salesCenterAgent = await isSalesCenterAgent(firstState.hcStorage.agent_id)

  const onSubmit = (valuesForm, agentInformation) => {
    const state = store.getState()
    const statePlanId = state[propertyPlanId]
    if (statePlanId === undefined && IS_FIXED_BENEFIT_MEDICAL) {
      sendFBMPlansViaEmail(valuesForm, agentInformation, config, salesCenterAgent)
    } else {
      sendQuoteViaEmail(
        valuesForm,
        agentInformation,
        config,
        salesCenterAgent,
        propertyPlanId
      )
    }
  }

  enableSaveQuoteAgent(enable, onSubmit)
}

export default saveThisQuoteConfig
